import { paymentApi, planApi } from '@shared/api/server'

import {
  PaymentMethodType,
  PlanBuyRequestDto,
  PlanBuyResponseDto
} from '../types'
import { PlanModel } from './plan.model'

export interface IPlanRepository {
  getList(): Promise<PlanModel[]>
  getMethodsList(): Promise<PaymentMethodType[]>
  payPlan(payload: PlanBuyRequestDto): Promise<PlanBuyResponseDto>
}

export class PlanRepository implements IPlanRepository {
  async getList(): Promise<PlanModel[]> {
    const response = await planApi.getUserPlans()
    if (!response || response.length === 0) {
      return []
    }
    const list = response.map(
      (item) =>
        new PlanModel(
          item.id,
          item.name,
          item.name_en,
          item.daysGranted,
          item.price,
          item.price_usd
        )
    )
    return list
  }
  async getMethodsList(): Promise<PaymentMethodType[]> {
    try {
      const response = await paymentApi.getPaymentMethodsCall({})
      if (!response || response.length === 0) {
        return []
      }
      return response.map((item) => ({
        currency: item.currencyCode,
        id: item.id,
        network: item.payMethodCode,
        serviceName: item.payServiceName
      }))
    } catch {
      return []
    }
  }

  async payPlan(payload: PlanBuyRequestDto): Promise<PlanBuyResponseDto> {
    if (!payload.paymentCurrency || !payload.paymentNetwork) {
      return Promise.reject('Payment method is not selected')
    }
    const response = await paymentApi.paymentRequestCall({
      periodDays: payload.daysCount,
      sumInputCurrencyCode: payload.paymentCurrency,
      outerPayMethodType: payload.paymentNetwork
    })
    return response
  }
}
